"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ButtonIconMixin = require("../../mixins/components/ButtonIconMixin");
var ButtonIcon = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "ButtonIcon",
  componentId: "c11n-8-107-0__sc-tkmq02-0"
})(["", ""], _ButtonIconMixin.ButtonIconMixin);
exports.ButtonIcon = ButtonIcon;
ButtonIcon.displayName = 'ButtonIcon';

/** @component */